/* =======================================================================
   Preditiva Gult Premium V2
   facets.js — Ordenação, filtros e seletor de colunas (coleção + busca).
   Estratégia: navegação por query params (page reload), sem AJAX.
   Sections marcam o root com [data-facets-root].
   ======================================================================= */
(function () {
  'use strict';

  var DEBOUNCE_MS = 500;
  var STORAGE_KEY = 'gult:collection-columns';

  var debounceFn = typeof debounce === 'function'
    ? debounce
    : function (fn, wait) {
        var t;
        return function () {
          var args = arguments;
          clearTimeout(t);
          t = setTimeout(function () { fn.apply(null, args); }, wait);
        };
      };

  /* --- Ordenação: troca sort_by preservando os demais params --- */
  function initSort(root) {
    var select = root.querySelector('[data-sort-select]');
    if (!select) return;
    select.addEventListener('change', function () {
      var params = new URLSearchParams(window.location.search);
      params.set('sort_by', select.value);
      params.delete('page'); // volta à página 1 ao reordenar
      window.location.href = window.location.pathname + '?' + params.toString();
    });
  }

  /* --- Filtros: form GET → monta URL a partir do FormData (ignora vazios) --- */
  function submitFilters(form) {
    var params = new URLSearchParams();
    var data = new FormData(form);
    data.forEach(function (value, key) {
      if (String(value).trim() !== '') params.append(key, value);
    });
    var base = form.getAttribute('action') || window.location.pathname;
    var query = params.toString();
    window.location.href = query ? base + '?' + query : base;
  }

  function initFilters(root) {
    var form = root.querySelector('[data-facets-form]');
    if (!form) return;
    var scheduled = debounceFn(function () { submitFilters(form); }, DEBOUNCE_MS);

    form.addEventListener('change', function (event) {
      if (event.target.matches('[data-facet-input]')) scheduled();
    });
    form.addEventListener('submit', function (event) {
      event.preventDefault();
      submitFilters(form);
    });
  }

  /* --- Colunas: troca grid--3/grid--4 client-side + persiste --- */
  function initColumns(root) {
    var buttons = root.querySelectorAll('[data-columns]');
    var grid = root.querySelector('[data-product-grid] .grid');
    if (!buttons.length || !grid) return;

    function apply(cols) {
      grid.classList.remove('grid--2', 'grid--3', 'grid--4');
      grid.classList.add('grid--' + cols);
      buttons.forEach(function (btn) {
        btn.classList.toggle('is-active', btn.dataset.columns === cols);
      });
    }

    var saved = null;
    try { saved = localStorage.getItem(STORAGE_KEY); } catch (e) { /* modo privado */ }
    if (saved === '3' || saved === '4') apply(saved);

    buttons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        apply(btn.dataset.columns);
        try { localStorage.setItem(STORAGE_KEY, btn.dataset.columns); } catch (e) { /* noop */ }
      });
    });
  }

  function init() {
    document.querySelectorAll('[data-facets-root]').forEach(function (root) {
      initSort(root);
      initFilters(root);
      initColumns(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
